import CreateContent from "./CreateContent";

export default function CreatePost() {
  return <CreateContent type="POST" />;
}
